/* eslint-disable no-restricted-syntax */
import enSG from "../language/en-SG"
import zhCN from "../language/zh-CN"
import Th from "../language/th-TH"

import { customLanguages, enableTranslation as _enableTranslation } from "../customization/language"

export const enableTranslation = _enableTranslation

export const supportLanguages = [
  {
    id: `en-SG`,
    name: `English (Singapore)`,
    isDefault: true,
  },
  {
    id: `zh-CN`,
    name: `Chinese (Simplified, China)`,
    isDefault: false,
  },
  {
    id: `th-TH`,
    name: `ไทย`,
    isDefault: false,
  }
]

export const getLanguageResources = () => {

  // use default
  let langEnSg = enSG
  let langZhCn = zhCN
  let langTh = Th

  if (Object.prototype.hasOwnProperty.call(customLanguages, `en-SG`)) {
    // langEnSg = customLanguages[`en-SG`]

    Object.keys(customLanguages[`en-SG`]).forEach(i => {
      langEnSg[`_${i}`] = customLanguages[`en-SG`][i]
    })

  }

  if (Object.prototype.hasOwnProperty.call(customLanguages, `zh-CN`)) {
    Object.keys(customLanguages[`zh-CN`]).forEach(i => {
      langZhCn[`_${i}`] = customLanguages[`zh-CN`][i]
    })
  }

  if (Object.prototype.hasOwnProperty.call(customLanguages, `th-TH`)) {
    Object.keys(customLanguages[`th-TH`]).forEach(i => {
      langTh[`_${i}`] = customLanguages[`th-TH`][i]
    })
  }

  const resources = {
    [`en-SG`]: langEnSg,
    [`zh-CN`]: langZhCn,
    [`th-TH`]: langTh,
  };

  return resources

}
